import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { autoSelectFirstLyrics } from './autoSelectLyrics';
import { useOrder } from './useOrder';
import { Page } from './ui';

export default function LyricsPage() {
  const { slug = '' } = useParams();
  const navigate = useNavigate();
  const { order, error, loading } = useOrder(slug);
  const [busy, setBusy] = useState(false);
  const [selectError, setSelectError] = useState('');
  const started = useRef(false);

  useEffect(() => {
    if (!order || started.current || busy) return;
    if (order.status === 'letras_prontas' && order.lyricsOptions?.length) {
      started.current = true;
      setBusy(true);
      autoSelectFirstLyrics(order)
        .then(() => navigate(`/criar-musica/gravando/${order.slug}`, { replace: true }))
        .catch((err) => {
          started.current = false;
          setBusy(false);
          setSelectError(err instanceof Error ? err.message : 'select_lyrics_failed');
        });
    }
  }, [order, busy, navigate]);

  if (loading) return <Page><section className="cm-panel"><p className="cm-kicker">Carregando…</p></section></Page>;
  if (error || !order) return <Page><section className="cm-panel"><p className="cm-error">{error || 'Pedido não encontrado.'}</p></section></Page>;

  return (
    <Page>
    <section className="cm-panel">
      <p className="cm-kicker">Preparando a prévia</p>
      <h1 className="cm-title">A gente escolhe a letra e segue pra gravação.</h1>
      <p className="cm-lead">Você não precisa ler três opções. Em seguida a gente canta 1 minuto da música de {order.recipientName}.</p>
      {(busy || order.status === 'gerando_letras' || order.status === 'letras_prontas') && (
        <p className="cm-note">Tá nascendo a música de {order.recipientName}…</p>
      )}
      {selectError && <p className="cm-error">Não deu pra seguir agora. Atualize a página.</p>}
    </section>
    </Page>
  );
}
